import api from "@/plugins/api";
import { changeTheme, defaultTheme } from "@/utils/functions";
import vuetify from "@/plugins/vuetify";

const state = () => ({
  userTheme: defaultTheme,
  updateTheme: true,

  hasProfileInfo: false,

  order_filters: {},
  sale_order_filters: {},
  adhoc_order_filters: {},
  driver_filters: {},
  vehicle_filters: {},
  customer_address_filters: {},
  trip_filters: {},
  trip_planning_filters: {},
  normal_user_filters: {},
  item_filters: {},

  userDetails: {},
});

const getters = {};

const mutations = {
  initialiseStore(state) {
    let data = localStorage.getItem("user_data");
    if (data) {
      data = JSON.parse(data);
      if (
        data.company_details &&
        data.company_details.configuration &&
        data.company_details.configuration.theme
      ) {
        state.userTheme = data.company_details.configuration.theme;
        if (state.userTheme) {
          changeTheme(state.userTheme, vuetify.framework);
        } else {
          changeTheme(defaultTheme, vuetify.framework);
        }
      }
      state.userDetails = data;
      if (
        data.filters &&
        typeof data.filters == typeof {} &&
        Object.keys(data.filters).length > 0
      ) {
        for (const property in data.filters) {
          state[property] = data.filters[property];
        }
      }
      state.hasProfileInfo = true;
    }
  },
  updateUserDetails(state, data) {
    state.userDetails = data;
    localStorage.setItem("user_data", JSON.stringify(data));
  },
  updateTheme(state, data) {
    state.userTheme = data;
    if (state.userTheme) {
      changeTheme(state.userTheme, vuetify.framework);
    } else {
      changeTheme(defaultTheme, vuetify.framework);
    }
  },
  updateUserFilters(state, data) {
    if (data && typeof data == typeof {} && Object.keys(data).length > 0) {
      for (const property in data) {
        state[property] = data[property];
      }
      let userData = JSON.parse(localStorage.getItem("user_data"));
      userData = {
        ...userData,
        filters: data,
      };
      localStorage.setItem("user_data", JSON.stringify(userData));
    }
    state.hasProfileInfo = true;
  },
  setFilters(state, data) {
    state[data.moduleKey] = {
      ...state[data.moduleKey],
      ...data.payload,
    };
    let filterObj = { ...state[data.moduleKey] };
    for (const property in filterObj) {
      if (filterObj[property] == null || filterObj[property] == undefined) {
        delete filterObj[property];
      }
      if (
        filterObj[property] &&
        Array.isArray(filterObj[property]) &&
        filterObj[property].length == 0
      ) {
        delete filterObj[property];
      }
      if (
        typeof filterObj[property] == typeof {} &&
        Object.keys(filterObj[property]).length == 0
      ) {
        delete filterObj[property];
      }
    }

    state[data.moduleKey] = { ...filterObj };
  },
  resetFilters(state, data) {
    state[data.moduleKey] = {};
  },
  removeFilter(state, data) {
    if (data.filterKey === "start_date" || data.filterKey === "end_date") {
      delete state[data.moduleKey].start_date;
      delete state[data.moduleKey].end_date;
    } else {
      delete state[data.moduleKey][data.filterKey];
    }
  },
};

const actions = {
  getUserProfileInfo({ commit }) {
    return new Promise((resolve, reject) => {
      api.profile
        .getUserProfile()
        .then((res) => {
          commit("updateUserDetails", res.data);
          commit("updateTheme", res.data.company_details?.configuration?.theme);
          commit("updateUserFilters", res.data.filters);
          resolve(res.data);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },
  getUserFilters() {
    return api.profile.getUserFilters;
  },
  updateUserFilters({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.profile
        .updateUserFilters(payload)
        .then((res) => {
          commit("updateUserFilters", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
